import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';

import { colors, layout } from 'Constants';

import { Container, Footnote, Anchor } from 'Components/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FacebookIcon from './images/footer_fb.svg';
import TwitterIcon from './images/footer_twitter.svg';
import YoutubeIcon from './images/footer_yt.svg';

import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';
import CODES from 'Root/libs/analytics/CodeDef';

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;


  color: ${colors.textOnAccent};
  text-align: center;
`;

const SocialAnchor = styled(Anchor)`
  align-self: flex-start;
  margin-bottom: 20px;
`;

const SocialAnchor2 = styled(Anchor)`
  align-self: flex-start;
  margin-bottom: 20px;
  color: #ffffff;

 
`;

const FooterFootnote = styled(Footnote)`
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #fff;
  margin-top: 40px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
  padding:20px;

  }
`;

const SocialIconText=styled.div`
font-family: "Elevance Sans Medium";
font-size: 16px;
line-height: 22px;
text-align: left;
color: #fff;

`;

const SingleSocialAnchor2 = ({ text, icon, code, to }) => {
  return (
    <div style={{marginLeft:20}}>
      <SocialAnchor2 code={code} to={to} target="_blank">
        <div style={{display:'flex',alignItems:"center"}}>
          <div style={{marginRight:20}}>
            <img alt="Facebook" src={icon} style={{ width: 32, height: 32 }} />
          </div>
          <SocialIconText>{text}</SocialIconText>
        </div>
      </SocialAnchor2>
     
      <div style={{paddingLeft:50,marginTop:10}}>
        <hr/>
      </div>
    </div>
  );
};

// TODO: Implement API values



const InnerContainer=styled(Container)`

max-width:${layout.maxWidth} ;
background-color:#333333 ;
padding: 60px 120px 120px 120px ;
width:100% ;
@media screen and (max-width: ${layout.breakpoints.mobile}) {
  padding: 0px 0px 0px 0px ;

}


`;



const TextContainer=styled.div`

align-items:flex-start ;
justify-content:flex-start ;
flex:1;
display:flex;
flex-direction:column ;

@media screen and (max-width: ${layout.breakpoints.mobile}) {
  width:400px;
  flex:unset;
  margin:20px;

}



`;

export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <FooterContainer>
           
      
        <InnerContainer
           
          column
        >
        

          <Container   style={{flexWrap:'wrap' }}>



            <TextContainer
             
            >




              <SocialAnchor
                code={CODES.FOOT_ANTHEM_LINK}
                to={state.brandInfo.webLink}
                color={colors.textOnAccent}
              >
                {state.brandInfo.name}
              </SocialAnchor>

              <SocialAnchor
                code={CODES.FOOT_PP_LINK}
                to={state.brandInfo.privacyPolicy}
                color={colors.textOnAccent}
              >
                PRIVACY POLICY
              </SocialAnchor>

              <SocialAnchor
                code={CODES.FOOT_LEGAL_LINK}
                to={state.brandInfo.legal}
                color={colors.textOnAccent}
              >
                LEGAL
              </SocialAnchor>
            </TextContainer>

            {state.socials && <Container   column>
              <SingleSocialAnchor2
                text="Follow us on X"
                icon={TwitterIcon}
                code={CODES.FOOT_SOCIAL_TW}
                to={state.socials.twitter}
                alt="X"
              />

              <SingleSocialAnchor2
                text="Subscribe to our YouTube channel"
                icon={YoutubeIcon}
                code={CODES.FOOT_SOCIAL_YT}
                to={state.socials.youtube}
                alt="Youtube"
              />

              <SingleSocialAnchor2
                text="Friend us on Facebook"
                icon={FacebookIcon}
                code={CODES.FOOT_SOCIAL_FB}
                to={state.socials.facebook}
                alt="Facebook"
              />
            </Container>}

            <Container
              seperation="36px"
              style={{ alignSelf: 'center' }}
            ></Container>
          </Container>
          <Container>
          {state.formNumber||""}
          <br/>
          </Container>
          <FooterFootnote>{state.brandInfo.legalText}</FooterFootnote>
        </InnerContainer>
      </FooterContainer>
    )}
  </Subscribe>
);
